// extracted by mini-css-extract-plugin
export default {"documentView":"documentView--cGHPi","wrapperRight":"wrapperRight--rXXuh"};